import type { RootState } from '@app/types';
import { createContext, useContext } from 'react';
import initialState from './initialState';

export type NavigationPanelContextType = {
    project: RootState['project'];
    branch: RootState['branch'];
    userRights: RootState['userRights'];
    features: RootState['features'];
    badges: RootState['badges'];
    session: RootState['session'];
    team: RootState['team'];
};

export const NavigationPanelContext = createContext<NavigationPanelContextType>(initialState);

export const useNavigationPanelContext = () => {
    const context = useContext(NavigationPanelContext);

    if (context === undefined) {
        throw new Error('useNavigationPanelContext must be used within a project.');
    }

    return context;
};
